export default "__VITE_ASSET__CnXGW5t0__"